import React from 'react';
import { JunoDialog } from '../JunoDialog';

interface RestrictCoursePreviewDialogProps {
  handleClose: () => void;
  handleUpgrade: (url: string) => void;
  upgradeUrl: string;
}

const RestrictCoursePreviewDialog: React.FC<RestrictCoursePreviewDialogProps> = ({
  handleClose,
  handleUpgrade,
  upgradeUrl,
}) => {
  if (upgradeUrl) {
    return (
      <JunoDialog
        open
        id='registration-required-dialog'
        title='Premium Content'
        subtitle='Registration is required to access this course.'
        message='Please click the registration button below for more information and to sign-up.'
        mode='confirmation'
        primaryBtnProps={{
          onClick: () => handleUpgrade(upgradeUrl),
          title: 'Register',
        }}
        onClose={handleClose}
        secondaryBtnProps={{
          onClick: handleClose,
          title: 'Cancel',
        }}
      />
    );
  }

  return (
    <JunoDialog
      open
      id='exclusive-content-dialog'
      title='Exclusive Content'
      subtitle='This course is a part of our exclusive collection.'
      message='Public registration is not available at this time.'
      mode='info'
      primaryBtnProps={{
        onClick: handleClose,
        title: 'I Understand',
      }}
      onClose={handleClose}
    />
  );
};

export default RestrictCoursePreviewDialog;
